import styled from 'styled-components';

export const Wrapper = styled.div`
    align-items: baseline;
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    color: #fff;
`;

export const ClockWrapper = styled.div`
    background-color: #029100;
    padding: 0 24px;
`;